import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import UploadFileIcon from '@mui/icons-material/UploadFile'; // Icono opcional
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useSnackbar } from 'notistack';

import api from '../../../../utils/axiosInstance';

import styles from '../Intimidad/Intimidad.module.css';
export const SaveOption = (props) => {
  const { enqueueSnackbar } = useSnackbar();

  return (
    <div className={styles.intimidad}>
      <div className={styles.top}>
        <h3 className={styles.title}>¿Quieres habilitar opción de guardado de encuesta?</h3>
        <p className={styles.subtitle}>
          La opción de guardado te permite pausar la encuesta durante la ejecución.
        </p>
        <p className={styles.subtitle}>
          Solo aplica para las preguntas de tipo: Likert, Selección, Abierta y Escala opinión
        </p>
      </div>

        <div className={styles.bottom}>
        <FormControl>
            <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={props.saveOption.toString()} // guarda "true" o "false"
            onChange={(e) => props.setSaveOption(e.target.value === 'true')} // convierte a boolean real
            >
            <FormControlLabel
                value="true"
                control={<Radio />}
                label="Sí. Habilitar opción de guardado"
            />
            <FormControlLabel
                value="false"
                control={<Radio />}
                label="No. Guardar al finalizar la encuesta"
            />
            </RadioGroup>
        </FormControl>
        </div>


    </div>
  );
};

